module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headers"
  }, [_c('div', {
    staticClass: "tool-wrap"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.callPhone(4006027009)
      }
    }
  }, [_c('img', {
    staticClass: "tool dh",
    attrs: {
      "src": require("../assets/dh.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('swiper', {
    staticClass: "banner",
    attrs: {
      "options": _vm.swiperOptions,
      "complete": _vm.complete
    }
  }, [_vm._l((_vm.banner), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide",
      attrs: {
        "data-url": item['adUrl']
      },
      on: {
        "click": function($event) {
          return _vm.jump(item.adUrl)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.adImgUrl,
        "alt": ""
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "block2"
  }, [_c('div', {
    staticClass: "tab-out"
  }, [_c('div', {
    staticClass: "tab-wrap"
  }, [_c('div', {
    staticClass: "tab-in"
  }, [_c('div', {
    staticClass: "tab",
    class: {
      'act': _vm.chotab == 1
    },
    on: {
      "click": function($event) {
        return _vm.chotabs(1)
      }
    }
  }, [_c('p', [_vm._v("智慧经营")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      'act': _vm.chotab == 2
    },
    on: {
      "click": function($event) {
        return _vm.chotabs(2)
      }
    }
  }, [_c('p', [_vm._v("智慧工程")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      'act': _vm.chotab == 3
    },
    on: {
      "click": function($event) {
        return _vm.chotabs(3)
      }
    }
  }, [_c('p', [_vm._v("云采购")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      'act': _vm.chotab == 4
    },
    on: {
      "click": function($event) {
        return _vm.chotabs(4)
      }
    }
  }, [_c('p', [_vm._v("智慧营销")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      'act': _vm.chotab == 5
    },
    on: {
      "click": function($event) {
        return _vm.chotabs(5)
      }
    }
  }, [_c('p', [_vm._v("空间运营")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      'act': _vm.chotab == 6
    },
    on: {
      "click": function($event) {
        return _vm.chotabs(6)
      }
    }
  }, [_c('p', [_vm._v("服务与支持")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), (_vm.chotab == 1) ? _c('div', {
    staticClass: "mes-wrap"
  }, [_c('img', {
    staticClass: "top",
    attrs: {
      "src": require("../assets/tab1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("全面助力房企数字化转型")]), _vm._v(" "), _c('p', {
    staticClass: "mes"
  }, [_vm._v("多年地产深耕，依托行业实践及前沿技术，明源云自主研发数字化创新方案与产品，提供企业级云ERP整体解决方案。\n                    聚焦数据和技术优势，赋能房企智能化运营和数字化创新能力，打通信息孤岛、连接碎片场景、提升管理效能，实现房企业务规模和商业模式的突破。")]), _vm._v(" "), _c('div', {
    staticClass: "bt-wrap"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/myy/product',
        query: {
          tab: 'yunERP'
        }
      }
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("查看详情 >")])]), _vm._v(" "), _vm._m(3)], 1)]) : _vm._e(), _vm._v(" "), (_vm.chotab == 2) ? _c('div', {
    staticClass: "mes-wrap"
  }, [_c('img', {
    staticClass: "top",
    attrs: {
      "src": require("../assets/tab2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("地产工程建造数字化引领者")]), _vm._v(" "), _c('p', {
    staticClass: "mes"
  }, [_vm._v("明源云链致力于通过领先的移动互联网+大数据技术，让地产工程建造环节及上下游各方的业务场景在线化。通过在线，提升建造环\n                    节的生产效率、环境安全和产品品质，以及上下游的协同效率；并运用领先的大数据算法为各方赋能，最终让房企的采购更智慧\n                    、工程管理更智慧、交付维保更智慧。")]), _vm._v(" "), _c('div', {
    staticClass: "bt-wrap"
  }, [(!_vm.isMini) ? _c('a', {
    attrs: {
      "href": "http://m.myfuwu.com.cn/"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("查看详情 >")])]) : _vm._e(), _vm._v(" "), _c('a', {
    style: (("margin:" + (_vm.isMini?'auto':'unset') + ";")),
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/opport/76389eb7-b3a5-4335-a224-9dfb16d13481/1"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("申请体验 >")])])])]) : _vm._e(), _vm._v(" "), (_vm.chotab == 3) ? _c('div', {
    staticClass: "mes-wrap"
  }, [_c('img', {
    staticClass: "top",
    attrs: {
      "src": require("../assets/tab3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("让地产供应链更智慧")]), _vm._v(" "), _c('p', {
    staticClass: "mes"
  }, [_vm._v("\n                    明源云采购于2014年7月1日上线，致力于打破供需双方的信息隔阂，有效匹配地产供应链上下游资源，让地产供应链更智慧，明源云采购以“开发商智慧采购+供应商智慧营销”为产品依托，目前已经累计为3300+家开发商的270,000+家供应商提供供需直连的精准高效服务。")]), _vm._v(" "), _c('div', {
    staticClass: "bt-wrap"
  }, [(!_vm.isMini) ? _c('a', {
    attrs: {
      "href": "https://m.mycaigou.com/"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("查看详情 >")])]) : _vm._e(), _vm._v(" "), _c('a', {
    style: (("margin:" + (_vm.isMini?'auto':'unset') + ";")),
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/opport/76389eb7-b3a5-4335-a224-9dfb16d13481/1"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("申请体验 >")])])])]) : _vm._e(), _vm._v(" "), (_vm.chotab == 4) ? _c('div', {
    staticClass: "mes-wrap"
  }, [_c('img', {
    staticClass: "top",
    attrs: {
      "src": require("../assets/tab4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("产品覆盖全国，市场占有率稳居行业首位")]), _vm._v(" "), _c('p', {
    staticClass: "mes"
  }, [_vm._v("\n                    明源云客以大数据为基础，引入前沿科技，结合智能软硬件，为传播、渠道、案场、交易等房地产营销全链条多环节，提供多场景智能应用，打造全新一代智慧营销体系。覆盖全国30+区域机构，超3000人专业团队，直连企业内部，无地域边界提供专业服务。")]), _vm._v(" "), _c('div', {
    staticClass: "bt-wrap"
  }, [(!_vm.isMini) ? _c('a', {
    attrs: {
      "href": "http://www.myunke.com/mobile/index.html"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("查看详情 >")])]) : _vm._e(), _vm._v(" "), _c('a', {
    style: (("margin:" + (_vm.isMini?'auto':'unset') + ";")),
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/opport/76389eb7-b3a5-4335-a224-9dfb16d13481/1"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("申请体验 >")])])])]) : _vm._e(), _vm._v(" "), (_vm.chotab == 5) ? _c('div', {
    staticClass: "mes-wrap"
  }, [_c('img', {
    staticClass: "top",
    attrs: {
      "src": require("../assets/tab5.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("不动产资产管理数字化领航者")]), _vm._v(" "), _c('p', {
    staticClass: "mes"
  }, [_vm._v("明源云空间专注为经营性不动产提供资产管理及运营数字化解决方案，赋能存量资产经营客户提升商业市场资产价值，涉及公寓、商办、\n                    园区、商业、住宅社区等业态；核心聚焦资产管理、资产运营、物业管理与客户服务业务板块，帮助链接企业、企业员工、消费者、业主，沉淀存量大数据，通过数据智能驱动存量资产价值新增长。")]), _vm._v(" "), _c('div', {
    staticClass: "bt-wrap"
  }, [(!_vm.isMini) ? _c('a', {
    attrs: {
      "href": "http://www.myykj.com.cn/"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("查看详情 >")])]) : _vm._e(), _vm._v(" "), _c('a', {
    style: (("margin:" + (_vm.isMini?'auto':'unset') + ";")),
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/opport/76389eb7-b3a5-4335-a224-9dfb16d13481/1"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("申请体验 >")])])])]) : _vm._e(), _vm._v(" "), (_vm.chotab == 6) ? _c('div', {
    staticClass: "mes-wrap"
  }, [_c('img', {
    staticClass: "top",
    attrs: {
      "src": require("../assets/tab6.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("在线化、智能化的专业服务体系,为客户提供最佳系统保障与应用服务体验")]), _vm._v(" "), _c('p', {
    staticClass: "mes"
  }, [_vm._v("明源支持服务基于全渠道在线服务平台，集合智能运维系统和专业服务团队，打造在线化、智能化、专业化的服务体系，\n                    保障系统全天候稳定运行，为客户提供最佳应用体验和业务提升服务。")]), _vm._v(" "), _c('div', {
    staticClass: "bt-wrap"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/myy/product',
        query: {
          tab: 'suport'
        }
      }
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("查看详情 >")])]), _vm._v(" "), _vm._m(4)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block3"
  }, [_vm._m(5), _vm._v(" "), _c('swiper', {
    staticClass: "swiper1",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "wrap-out",
    on: {
      "click": function($event) {
        return _vm.jump('https://m.mingyuanyun.com/myy/detail/39f49d0e-4416-5039-b8ac-af3c10c04049')
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/unit11.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("金地、绿地、中海宏洋竟这样做工程精细化管理，提质降本一步到位！")]), _vm._v(" "), _c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("../assets/jt2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "wrap-out",
    on: {
      "click": function($event) {
        return _vm.jump('https://m.mingyuanyun.com/myy/detail/39f49d13-9602-4dbb-6d35-0c612bba59ca')
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/unit12.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("金茂的地产数字化，竟然已经进化到这种程度了！")]), _vm._v(" "), _c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("../assets/jt2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "wrap-out",
    on: {
      "click": function($event) {
        return _vm.jump('https://m.mingyuanyun.com/myy/detail/39f49d14-3f92-992b-cb25-3e6bf5675ea5')
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/unit13.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("房企被分销绑架？可能是因为你犯了这些错")]), _vm._v(" "), _c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("../assets/jt2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "wrap-out",
    on: {
      "click": function($event) {
        return _vm.jump('https://m.mingyuanyun.com/myy/detail/39f49d15-58ec-4bc1-9dec-bfb33787de15')
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/unit14.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("地产下半场，新的万亿市场！房企想分一杯羹，必须过3关")]), _vm._v(" "), _c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("../assets/jt2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block3"
  }, [_vm._m(6), _vm._v(" "), _c('swiper', {
    staticClass: "swiper1",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "wrap-out",
    on: {
      "click": function($event) {
        return _vm.jump('https://m.mingyuanyun.com/myy/detail/39f49d16-5564-840c-4f0e-39fc919b3f94')
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/unit21.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("探索房企数字化转型趋势，开放与共创成为主流")]), _vm._v(" "), _c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("../assets/jt2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "wrap-out",
    on: {
      "click": function($event) {
        return _vm.jump('https://m.mingyuanyun.com/myy/detail/39f49d17-316e-4a43-ee4d-3c04f3d9384a')
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/unit22.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("明源云 | 聚焦等保三级认证，为数字房企安全加码")]), _vm._v(" "), _c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("../assets/jt2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "wrap-out",
    on: {
      "click": function($event) {
        return _vm.jump('https://m.mingyuanyun.com/myy/detail/39f49d17-f7cb-3799-8b93-dd051218a478')
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/unit23.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("谈谈数字化时代，ERP如何坐稳数字化底座")]), _vm._v(" "), _c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("../assets/jt2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block3"
  }, [_vm._m(7), _vm._v(" "), _c('swiper', {
    staticClass: "swiper1",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "wrap-out",
    on: {
      "click": function($event) {
        return _vm.jump('https://m.mingyuanyun.com/inst/article-detail/39f4cb9e-c436-13c7-4082-b908b07fe848')
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/unit31.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("明源云荣获2020艾瑞企业服务奖")]), _vm._v(" "), _c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("../assets/jt2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "wrap-out",
    on: {
      "click": function($event) {
        return _vm.jump('https://m.mingyuanyun.com/myy/detail/39f49d1a-4f01-0a5b-8fd5-99107fa797a9')
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/unit32.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("明源云x阿里云｜共启地产供应链协同平台联合解决方案")]), _vm._v(" "), _c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("../assets/jt2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "wrap-out",
    on: {
      "click": function($event) {
        return _vm.jump('https://m.mingyuanyun.com/myy/detail/39f49d1b-7db4-4d87-141a-63b183a0e6a3')
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../assets/unit33.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_c('span', [_vm._v("明源云与广联达签署战略合作，数字化重塑地产生态链")]), _vm._v(" "), _c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("../assets/jt2.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "block5"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("联系我们")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "inp-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "phone",
    attrs: {
      "type": "text",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company),
      expression: "company"
    }],
    staticClass: "comp",
    attrs: {
      "type": "text",
      "placeholder": "公司名称"
    },
    domProps: {
      "value": (_vm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bt-wrap"
  }, [_c('div', {
    staticClass: "bt sub",
    on: {
      "click": _vm.submes
    }
  }, [_vm._v("提交需求")]), _vm._v(" "), _c('div', {
    staticClass: "bt zx",
    on: {
      "click": function($event) {
        return _vm.jump('http://p.qiao.baidu.com/cps/chat?siteId=15901763&userId=30829416&siteToken=970e63ec1da9aa35a1489c9a910ce734')
      }
    }
  }, [_vm._v("在线咨询\n                ")])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)], 1), _vm._v(" "), _c('j-alert2', {
    attrs: {
      "show": _vm.showAlert,
      "content": _vm.successMsg,
      "onHide": _vm.hideAlert
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/opport/76389eb7-b3a5-4335-a224-9dfb16d13481/1"
    }
  }, [_c('img', {
    staticClass: "tool kf",
    attrs: {
      "src": require("../assets/kf.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block1"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("“深耕数字科技，助力产业升级”")]), _vm._v(" "), _c('div', {
    staticClass: "line-out"
  }, [_c('div', {
    staticClass: "line-in"
  })]), _vm._v(" "), _c('p', {
    staticClass: "mes"
  }, [_vm._v("\n                明源云，是国内领先的不动产生态链数字化解决方案服务商，香港联交所主板上市（0909.HK），秉承“深耕数字科技，助力产业升级”的企业使命，坚持助客户成功的经营理念，明源云累计为7000多家不动产开发运营企业提供了数字化解决方案和产品。")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/detail/39f49d1c-04ca-1ade-f320-ab484c9e61d7"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("查看更多>")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jt"
  }, [_c('img', {
    staticClass: "line",
    attrs: {
      "src": require("../assets/line.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "jticon",
    attrs: {
      "src": require("../assets/jt.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/opport/76389eb7-b3a5-4335-a224-9dfb16d13481/1"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("申请体验 >")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/opport/76389eb7-b3a5-4335-a224-9dfb16d13481/1"
    }
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("申请体验 >")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tit"
  }, [_c('img', {
    staticClass: "titicon",
    attrs: {
      "src": require("../assets/tit.png"),
      "alt": ""
    }
  }), _vm._v("数字化案例\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tit"
  }, [_c('img', {
    staticClass: "titicon",
    attrs: {
      "src": require("../assets/tit.png"),
      "alt": ""
    }
  }), _vm._v("技术开放\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tit"
  }, [_c('img', {
    staticClass: "titicon",
    attrs: {
      "src": require("../assets/tit.png"),
      "alt": ""
    }
  }), _vm._v("生态共赢\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block4"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("\n                累计超过7000家开发商\n                "), _c('br'), _vm._v("90%以上百强房企的信赖之选\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "line-out"
  }, [_c('div', {
    staticClass: "line-in"
  })]), _vm._v(" "), _c('img', {
    staticClass: "logos",
    attrs: {
      "src": require("../assets/logos.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-out"
  }, [_c('div', {
    staticClass: "line-in"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block6"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/mingyuanyun/wx/activity/index?public_id=39d7a796-d356-3d6b-0e2c-d4d8f0cb818b&org_id=39d85bfe-c42a-5263-88a0-0fa388257b1e"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/icon1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("学习峰会")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/list/0"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/icon3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("典型案例")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://m.mingyuanyun.com/myy/list/1"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../assets/icon4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("明源动态")])])])]), _vm._v(" "), _c('img', {
    staticClass: "two",
    attrs: {
      "src": "https://huiyuanxitong.oss-cn-hangzhou.aliyuncs.com/mingyuanyun/gw/qr-code-my.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("\n                扫码添加“小明”\n                "), _c('br'), _vm._v("添加微信了解更多产品资讯\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block7"
  }, [_c('p', {
    staticClass: "mes"
  }, [_vm._v("地址：广东省深圳市南山区粤海街道高新南十道16号金地威新中心A座8F明源云")]), _vm._v(" "), _c('p', {
    staticClass: "mes"
  }, [_vm._v("\n                总机：0755-86309788\n                "), _c('span', {
    staticStyle: {
      "margin-left": "0.4rem"
    }
  }, [_vm._v("咨询热线400-6027-009")])]), _vm._v(" "), _c('p', {
    staticClass: "mes"
  }, [_vm._v("\n                深圳市明源云科技有限公司\n                "), _c('span', {
    staticStyle: {
      "margin-left": "0.2rem"
    }
  }, [_vm._v("粤ICP备12059233号")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dba4a08"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 286
// module chunks = 1